<template>
  <ConfigLayout current="customer/option">
    <ConfigPage title="顧客情報項目の追加">
      <template slot="header">
        <Button flat @click="$router.push({ name: 'optionOrder' })"><MoveIcon />並べ替え</Button>
        <Separator />
        <Popover placement="bottom-end" :disabled="isAddDisabled">
          <div slot="popover" class="option-type">
            <Button flat v-close-popover @click="current = { inputType: 5 }" class="type check">
              <CheckIcon />選択式
            </Button>
            <Button flat v-close-popover @click="current = { inputType: 1 }" class="type input">
              <inputIcon />入力式
            </Button>
          </div>
          <Button flat :disabled="isAddDisabled"><AddStrongIcon />新規</Button>
        </Popover>
      </template>
      <p>
        顧客情報に20件まで項目を追加することができます。<br />
        項目名に対する入力枠の形式を選んでください。顧客情報登録時に選択した入力フォームが表示されます。<br />
        ※追加した顧客情報項目は同じ企業にひもづく台帳で共通の設定となり、編集、削除を行うと、同じ企業にひもづく台帳すべてに反映されますのでご注意ください。
      </p>
      <DataTable
        class="option-list"
        :data="allOptions"
        :columns="[
          { key: 'label', name: '項目名' },
          { key: 'inputType', name: '形式', format: inputType => ({ 1: '入力式', 5: '選択式' }[inputType]) },
        ]"
        :minItemHeight="56"
        nodata="該当する顧客情報項目はありません"
        :loading="busy"
        editButton
        deleteButton
        @edit="current = $event"
        @delete="onDelete"
      >
      </DataTable>
      <CustomerOptionModal v-if="current" v-bind="current" @saved="fetch" @close="current = null" />
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import { Separator } from '@/components/molecules/PageHeader'
import Popover, { ClosePopover } from '@/components/molecules/Popover'
import DataTable from '@/components/molecules/DataTable'
import Dialog from '@/components/molecules/ModalDialog'
import CustomerOptionModal from '@/components/molecules/CustomerOptionModal'
import MoveIcon from '@/components/icons/move'
import AddStrongIcon from '@/components/icons/addStrong'
import CheckIcon from '@/components/icons/CheckIcon'
import inputIcon from '@/components/icons/inputIcon'

export default {
  name: 'Options',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    Separator,
    Popover,
    DataTable,
    CustomerOptionModal,
    MoveIcon,
    AddStrongIcon,
    CheckIcon,
    inputIcon,
  },
  directives: {
    ClosePopover,
  },
  data() {
    return {
      current: null,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.customers.options.busy,
    }),
    ...mapGetters({
      allOptions: 'customers/options/all',
    }),
    isAddDisabled() {
      return this.allOptions.length >= 20
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch('customers/options/get')
    },
    async onDelete({ id, label }) {
      if (
        !(await Dialog.confirm({
          title: '顧客情報項目削除',
          message: '以下の顧客情報項目が\n顧客情報から削除されますがよろしいですか？',
          target: label,
          description:
            '※追加した顧客情報項目は同じ企業にひもづく台帳で共通の設定となり、削除を行うと、同じ企業にひもづく台帳すべてに反映されますのでご注意ください。一度削除したデータは復元できません。',
          caution: true,
          cancelText: '戻る',
          okText: '削除',
        }))
      )
        return
      if (await this.$store.dispatch('customers/options/remove', id)) {
        this.fetch()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.option-type {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
}

.type {
  color: var(--text-color);
  font-size: 15px;
  padding: 12px 24px;
  &.check {
    svg {
      background: var(--moderate-blue);
      border-radius: 3px;
      height: 18px;
      margin: 3px 11px 3px 3px;
      width: 18px;
    }
  }
  &.input {
    fill: var(--moderate-blue);
  }
}
.option-list {
  >>> .inputType {
    justify-content: center;
    min-width: 93px;
    width: 93px;
  }
}
</style>
